import _typeof from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import ColorPicker from "@/pages/design/components/ColorPicker";
import Card from "@/pages/design/components/Card";
import CardItem from "@/pages/design/components/CardItem";
import { getURLFileName } from '@/pages/design/common/utils';
import draggable from "vuedraggable";
import YYImage from "@/pages/design/components/basic/image";
import no_img from '@/assets/noimg.png';
import FormEditPage from '@/pages/design/components/FormEditPage';
import { upload } from '@/services/common';
import SwiperHeightField from '@/pages/design/components/SwiperHeightField';
import GoodsListField from '@/pages/design/components/GoodsListField';
import Title from '@/pages/design/components/Title';
import ImgList from '@/pages/design/components/ImgList';
import InputBar from '@/pages/design/components/InputBar';
import InputNumber from '@/pages/design/components/InputNumber';
import { recommendProduct } from "@/services/design";
import Bus from "@/utils/bus";
import InputBarSelect from "@/pages/design/components/InputBar/InputBarSelect.vue";
import SubCard from "@/pages/design/components/subCard/subCard";
export default {
  i18n: require('../../design_i18n'),
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    Card: Card,
    CardItem: CardItem,
    draggable: draggable,
    YYImage: YYImage,
    FormEditPage: FormEditPage,
    SwiperHeightField: SwiperHeightField,
    Title: Title,
    ColorPicker: ColorPicker,
    GoodsListField: GoodsListField,
    ImgList: ImgList,
    InputBar: InputBar,
    InputNumber: InputNumber,
    InputBarSelect: InputBarSelect,
    SubCard: SubCard
  },
  watch: {
    'value.productList': function valueProductList() {
      this.value.product = this.value.productList.map(function (item) {
        return item.productSpecificationId;
      });
    }
  },
  methods: {
    numChange: function numChange() {
      // if (this.value.recommendNum === '' || this.value.recommendNum === null ) {
      //   this.value.recommendNum = 1
      // }
      this.switchProductType();
    },
    switchProductType: function switchProductType(val) {
      var _this = this;
      console.log('this.value.recommendNum=', _typeof(this.value.recommendNum));
      if (this.value.productType == "1" && this.value.recommendNum) {
        var defaultLangId = 0;
        var defaultLangObjStr = localStorage.cdefaultLangObj ? localStorage.cdefaultLangObj : localStorage.defaultLangObj;
        var defaultLangObj = JSON.parse(defaultLangObjStr);
        if (defaultLangObj) {
          defaultLangId = defaultLangObj.langId;
        }
        recommendProduct({
          num: this.value.recommendNum,
          langId: defaultLangId
        }).then(function (res) {
          console.log(res);
          if (res.data.code == 200) {
            _this.$set(_this.value, 'productList', res.data.data.productList);
          }
        });
      } else if (this.value.productType == "1" && this.value.recommendNum === null) {
        this.$set(this.value, 'productList', []);
      } else if (this.value.productType == "1" && this.value.recommendNum === '') {
        this.$set(this.value, 'productList', []);
      } else if (this.value.productType == "0") {
        this.$set(this.value, 'productList', this.productList);
      }
    },
    handleGoodsDelete: function handleGoodsDelete(item) {
      var id_index;
      this.value.product.forEach(function (x, i) {
        if (x == item.productSpecificationId) {
          id_index = i;
        }
      });
      var goods_index;
      this.value.productList.forEach(function (x, i) {
        if (x.productNo == item.productNo) {
          goods_index = i;
        }
      });
      var id_arr = [];
      if (typeof id_index != 'undefined') {
        id_arr = this.value.product.splice(id_index, 1);
      }
      var goods_arr = [];
      if (typeof goods_index != 'undefined') {
        goods_arr = this.value.productList.splice(goods_index, 1);
      }
      if (goods_arr.length > 0) {
        this.$message.success(this.$t('form.deleteSuccess'));
      } else {
        this.$message.error(this.$t('form.deleteError'));
      }
    }
  },
  mounted: function mounted() {
    if (this.value.productType == "0" || !this.value.productType) {
      this.productList = this.value.productList;
    }
  },
  data: function data() {
    return {
      form: this.$form.createForm(this),
      defaultFileList: [],
      no_img: no_img,
      showSlide: false,
      uploadLimit: 5,
      curImgItem: 0,
      // 点击编辑图片时的索引
      locationClient: [{
        label: this.$t('form.mobile'),
        value: 2
      }, {
        label: this.$t('form.pc'),
        value: 1
      }],
      /**
       * 下拉列表：大(318px)、中(235px)、小(147px)，自定义
       * 数字范围：1-500
       */
      pcHeight: [{
        label: '318',
        value: 318
      }, {
        label: '235',
        value: 235
      }, {
        label: '147',
        value: 147
      }],
      /**
       * 下拉列表：大(189px)、中(140px)、小(88px)，自定义
       * 数字范围：1-500
       */
      mHeight: [{
        label: '189',
        value: 189
      }, {
        label: '140',
        value: 140
      }, {
        label: '88',
        value: 88
      }],
      productType: 0,
      //商品类型  0:选择商品 1:推荐商品
      productList: [] //手动指定的商品列表
    };
  }
};